"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  disabled: false
};
exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/~/react-transition-group/cjs/config.js
// module id = 286
// module chunks = 0